import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import { CustomFieldContext, CustomFieldService } from "go-component/components/CustomField/services/context";
import { MessageEventContext, MessageEventService } from "go-component/components/MessageEvent/services/context";
import { SegmentContext, SegmentListService } from "go-segment/context";
import { adminApi } from "../../../../services/Api/Admin/adminApi";
import { adminApiSegment } from "../../../../services/Api/Admin/adminApiSegment";
import { api } from "../../../../services/Security/api";
import { hasRole, selectUser } from "../../../../services/users/selectors";
import AdminConfigurationPage from "./adminConfiugration";
import AdminReportsPage from "./adminReports";

const AdminPage = (props: RouteComponentProps) => {
	const user = useSelector(selectUser);
	const { t } = useTranslation();
	const hasPosnetRole = useSelector(hasRole("POSNET"));
	const hasOfficeRole = useSelector(hasRole("OFFICE"));
	const hasItSupportRole = useSelector(hasRole("IT_SUPPORT"));
	const hasSupportRole = useSelector(hasRole("SUPPORT"));
	const typesTranslationPrefix = "enums.message_events.type";
	const { addFlash } = useFlash();
	const segmentPath = `/admin/segments`;

	if (!user?.admin && !hasPosnetRole && !hasOfficeRole && !hasItSupportRole && !hasSupportRole) {
		const regex = /(^\/admin\/organizations\/\d+$)/;
		if (!regex.test(props.location.pathname)) {
			return <Redirect to={"/dashboard"} />;
		}
	}

	const resources = [
		{
			id: "ORGANIZATION",
			title: t("enums.message_events.resource_type.ORGANIZATION"),
			link: `/admin/organizations/`,
		},
	];

	const customFieldResources = [
		{
			id: "PARTNER",
			title: t(`enums.custom_fields.resources.PARTNER`),
		},
		{
			id: "ORGANIZATION",
			title: t(`enums.custom_fields.resources.ORGANIZATION`),
		},
	];

	return (
		<SegmentContext.Provider
			value={
				new SegmentListService(
					{
						saveSegment: adminApiSegment.saveSegment,
						removeSegment: adminApiSegment.removeSegment,
						getSegments: adminApiSegment.getSegments,
						restoreSegment: adminApiSegment.restoreSegment,
						updateSegment: adminApiSegment.updateSegment,
						updateSegments: adminApiSegment.updateSegments,
						setAsDefault: adminApiSegment.setSegmentAsDefault,
						setNotDefault: adminApiSegment.setSegmentNotDefault,
					},
					segmentPath,
					adminApiSegment.getListInfo,
					addFlash
				)
			}
		>
			<CustomFieldContext.Provider
				value={
					new CustomFieldService(
						{
							all: adminApi.getCustomFields,
							get: adminApi.getCustomField,
							create: adminApi.createCustomField,
							update: adminApi.updateCustomField,
							remove: adminApi.removeCustomField,
							restore: adminApi.restoreCustomField,
						},
						customFieldResources
					)
				}
			>
				<MessageEventContext.Provider
					value={
						new MessageEventService(
							{
								all: api.getMessageEvents,
								get: api.getMessageEvent,
								getTypeOptions: api.getMessageEventTypes,
							},
							resources,
							typesTranslationPrefix,
							t
						)
					}
				>
					<div className="page-container">
						<Switch>
							<Route path={`${props.match.url}/reports`} component={AdminReportsPage} />
							<Route path={`${props.match.url}`} component={AdminConfigurationPage} />
						</Switch>
						{/*<AdminNavigation match={props.match} history={props.history} location={props.location}/>*/}
						{/*<Switch>*/}
						{/*    <Route exact path={`${props.match.url}/`} component={AdminDashboardPage}/>*/}
						{/*    <Route path={`${props.match.url}/app_versions`} component={AdminAppVersionsPage}/>*/}
						{/*    <Route path={`${props.match.url}/apps`} component={AdminAppsPage}/>*/}
						{/*    <Route path={`${props.match.url}/organizations`} component={AdminOrganizationsPage}/>*/}
						{/*    <Route path={`${props.match.url}/users`} component={AdminUsersPage}/>*/}
						{/*    <Route path={`${props.match.url}/partners`} component={AdminPartnersPage}/>*/}
						{/*    <Route path={`${props.match.url}/tools`} component={AdminToolsPage}/>*/}
						{/*    <Route path={`${props.match.url}/crash_reports`} component={CrashReportsPage}/>*/}
						{/*    <Route path={`${props.match.url}/file_logs`} component={FileLogsPage}/>*/}
						{/*    <Route path={`${props.match.url}/custom_fields`} component={AdminCustomFieldsPage}/>*/}
						{/*    <Route path={`${props.match.url}/loans`} component={AdminLoansPage}/>*/}
						{/*    <Route path={`${props.match.url}/terminals`} component={AdminTerminalsPage}/>*/}
						{/*    <Route path={`${props.match.url}/terminals_report`} component={AdminTerminalReportPage}/>*/}
						{/*    <Route path={`${props.match.url}/devices_report`} component={AdminDeviceReportPage}/>*/}
						{/*    <Route path={`${props.match.url}/payoff`} component={AdminPayoffPage}/>*/}
						{/*    <Route path={`${props.match.url}/partner_report`} component={AdminPartnerReportPage}/>*/}
						{/*    <Route*/}
						{/*        path={`${props.match.url}/partner_payout_invoices`}*/}
						{/*        component={AdminPartnersPayoutInvoicesPage}*/}
						{/*    />*/}
						{/*    <Route*/}
						{/*        path={`${props.match.url}/organization_report`}*/}
						{/*        component={AdminOrganizationReportPage}*/}
						{/*    />*/}
						{/*    <Route path={`${props.match.url}/companies_report`} component={AdminCompaniesReportPage}/>*/}
						{/*    <Route*/}
						{/*        path={`${props.match.url}/transactions_report`}*/}
						{/*        component={AdminTransactionsReportPage}*/}
						{/*    />*/}
						{/*    <Route path={`${props.match.url}/organization_feature_usage_report`}*/}
						{/*           component={AdminOrganizationFeatureUsageReportPage}/>*/}
						{/*    <Route path={`${props.match.url}/organization_feature_report`}*/}
						{/*           component={AdminOrganizationFeatureReportPage}/>*/}
						{/*    <Route path={`${props.match.url}/accesses`} component={AdminAccessPage}/>*/}
						{/*    <Route path={`${props.match.url}/accesses_report`} component={AdminAccessReportPage}/>*/}
						{/*    <Route path={`${props.match.url}/transactions`} component={AdminTransactionsPage}/>*/}
						{/*    <Route path={`${props.match.url}/combo_reports`} component={AdminReportsComboPage}/>*/}
						{/*    <Route path={`${props.match.url}/go_launcher`} component={AdminGoLauncherPage}/>*/}
						{/*    <Redirect from={props.match.url} exact to={`${props.match.url}/`}/>*/}
						{/*    <Route component={Page404}/>*/}
						{/*</Switch>*/}
					</div>
				</MessageEventContext.Provider>
			</CustomFieldContext.Provider>
		</SegmentContext.Provider>
	);
};

export default AdminPage;

// t("enums.message_events.type.ORGANIZATION_CREATED");
// t("enums.message_events.type.ORGANIZATION_DELETED");
// t("enums.message_events.type.ORGANIZATION_BLOCKED");
// t("enums.message_events.type.ORGANIZATION_UNBLOCKED");
// t("enums.message_events.type.ORGANIZATION_UPDATED");
// t("enums.message_events.type.ORGANIZATION_RULES_ACCEPTED");
// t("enums.message_events.type.ORGANIZATION_REMOVED");
// t("enums.message_events.type.ORGANIZATION_INFO_UPDATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_CREATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_UPDATED");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_FROZEN");
// t("enums.message_events.type.ORGANIZATION_APPLICATION_DELETED");
